/**
 * クリップボードに任意のテキストをコピーするクラス
 * @see https://qiita.com/simiraaaa/items/2e7478d72f365aa48356
 */

export default class CopyToClipboard {
  constructor(_parm) {
    this.arrayElmsCopyBtn = [...document.querySelectorAll(_parm.copyBtn)]
  }

  /**
   * 今のページURLをコピー
   */
  copyUrl() {
    return navigator.clipboard.writeText(location.href);
  }

  /**
   * アラート要素を生成
   */
  createAlert(_text) {
    let elmAlert = document.createElement('div');
    elmAlert.textContent = _text;
    Object.assign(elmAlert.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '300px',
      padding: '20px 20px',
      color: '#fff',
      fontSize: '12px',
      textAlign: 'center',
      background: 'rgba(0,0,0,.8)',
      opacity: '0',
      transition: 'opacity .4s',
    });
    // アラート表示 → 非表示 → 要素削除
    async function sleep(delay, result) {
      return new Promise(resolve => {
        setTimeout(() => resolve(result), delay);
      });
    }
    async function exec() {
      document.body.appendChild(elmAlert);
      await sleep(200)
      elmAlert.style.opacity = 1;
      await sleep(1500)
      elmAlert.style.opacity = 0;
      await sleep(1000)
      elmAlert.remove();
    }
    exec();
  }

  addEvent() {
    this.arrayElmsCopyBtn.forEach(_elmCopyBtn => {
      _elmCopyBtn.addEventListener('click', (_ev) => {
        this.copyUrl().then(() => {
          this.createAlert('URLをコピーしました');
        }, () => {
          this.createAlert('URLのコピーに失敗しました<br>お使いのブラウザは対応していません');
        });
      })
    });
  }

  init() {
    this.addEvent();
  }
}
